<template>
  <a-card>
    <a-flex align="center" justify="space-between">
      <a-input placeholder="Поиск по номеру документа" />

      <PopoverMenu main-button-text="Массовые операции">
        <a-flex vertical gap="small">
          <a-button type="text">Подписать</a-button>

          <a-button type="text">Обновить статусы</a-button>
        </a-flex>
      </PopoverMenu>

      <columns-action
        v-model:dragList="markingCodesDocumentsStore.dragList"
        :initList="markingCodesDocumentsStore.columnsFiltered"
        :tableName="markingCodesDocumentsStore.columnsConfigName"
      />
    </a-flex>
  </a-card>
</template>

<script setup lang="ts">
import PopoverMenu from "@/components/UI/PopoverMenu.vue";
import { useMarkingCodesDocuments } from "@/stores/product/marking/marking-codes-documents.store";
import ColumnsAction from "@/components/base/table/ColumnsAction.vue";

const markingCodesDocumentsStore = useMarkingCodesDocuments();
</script>

<style scoped lang="scss">
.ant {
  &-btn {
    width: 100%;
  }

  &-input {
    max-width: 740px;
  }
}
</style>
